import React from 'react';
import { Route, Switch } from 'react-router';
import ViewUsers from './view';
import EditUsers from './edit';
import CreateUsers from './create';

const Users = () => {
  return (
    <Switch>
      <Route exact path='/admin/users' component={ViewUsers} />
      <Route exact path='/admin/users/new' component={CreateUsers} />
      <Route exact path='/admin/users/:id' component={EditUsers} /> 
    </Switch>
  );
};

export default Users;